import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import WhatWeManage from '../components/WhatWeManage';
import VideoShowcase from '../components/VideoShowcase';
import ProjectApproach from '../components/ProjectApproach';
import FeaturedProjects from '../components/FeaturedProjects';
import WhyChooseUs from '../components/WhyChooseUs';
import AboutUs from '../components/AboutUs';
import ContactSection from '../components/ContactSection';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';
import ScrollProgress from '../components/ScrollProgress';
import CustomCursor from '../components/CustomCursor';
import PageLoader from '../components/PageLoader';

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLoadComplete = () => {
    setIsLoading(false);
  };

  return (
    <div className="relative bg-[#0A0A0A]">
      {/* Page Loader */}
      <AnimatePresence>
        {isLoading && <PageLoader onLoadComplete={handleLoadComplete} />}
      </AnimatePresence>

      {/* Main Content - hidden until loader completes */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoading ? 0 : 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <CustomCursor />
        <ScrollProgress />
        <Navbar scrolled={scrolled} />
        <Hero />
        <WhatWeManage />
        <VideoShowcase />
        <ProjectApproach />
        <FeaturedProjects />
        <WhyChooseUs />
        <AboutUs />
        <ContactSection />
        <FinalCTA />
        <Footer />
      </motion.div>
    </div>
  );
};

export default HomePage;